<template>
  <div class="bg-white">
    <div class="break-all">
      {{ label }} : <b>{{ name }}</b>
    </div>
    <div class="w-full overflow-auto flex flex-nowrap mt-1 p-2">
      <div
        v-for="item in items"
        :key="item.id"
        class="ec-line002__sku__item"
        :class="{ selected: selected === item.id }"
        @click="onSelect(item.id)"
      >
        <text-ellipsis :rows="2">{{ item.name }}</text-ellipsis>
      </div>
    </div>
  </div>
</template>

<script>
import TextEllipsis from './TextEllipsis.vue'
export default {
  components: { TextEllipsis },
  props: {
    items: { type: Array, default: () => [] },
    label: { type: String, default: () => '' },
    selected: { type: [Number, String], default: () => null },
  },
  computed: {
    name() {
      return this.selected ? this.items.find((i) => i.id === this.selected)?.name : ''
    },
  },
  methods: {
    onSelect(id) {
      this.$emit('update:selected', id)
    },
  },
}
</script>

<style lang="scss" scoped>
@import '@/assets/css/components/ec-line002/sku-list.scss';
</style>
